import { render, staticRenderFns } from "./Form_Staff.vue?vue&type=template&id=4e0f4b1c"
import script from "./Form_Staff.vue?vue&type=script&lang=js"
export * from "./Form_Staff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports